/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Alt_Col_TypeInputs */

const en_pc_alt_col_type = /** @type {(inputs: Pc_Alt_Col_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What it is`)
};

const zh_pc_alt_col_type = /** @type {(inputs: Pc_Alt_Col_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`类型`)
};

/**
* | output |
* | --- |
* | "What it is" |
*
* @param {Pc_Alt_Col_TypeInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_alt_col_type = /** @type {((inputs?: Pc_Alt_Col_TypeInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Alt_Col_TypeInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_alt_col_type(inputs)
	return zh_pc_alt_col_type(inputs)
});
export { pc_alt_col_type as "pc.alt.col.type" }